<!--
    @name: 劳务搜索
    @description:
    @author: 徐朝成 xcc614@qq.com
    @time: 2021-08-26 17:53:32
-->
<template>
  <div :style="{ paddingTop: top ? '10px' : 0 }">
    <ScreenSort
      @changeobj="changeobj"
      :config="['industryType', 'locationAddress']"
      :secondCategoryi="3"
      :getquery="true"
    ></ScreenSort>
    <!-- 排序按钮组 -->
    <SortBtn :update="update" :distance="distance"></SortBtn>
    <div class="table" v-loading="loadingTrue">
      <div style="padding: 0 20px 10px 20px">
        <el-row :gutter="20" v-if="list.length">
          <el-col v-for="(item, index) in list" :span="12" :key="index">
            <card :item="item" :type="6"></card>
          </el-col>
          <template>
            <el-col :span="24" class="course-loading-wrap" v-show="moreLoading">
              数据加载中... <i class="el-icon-loading loading-icon"></i>
            </el-col>
            <el-col :span="24" class="course-loading-wrap" v-show="!moreLoading && nomore">没有更多数据了!</el-col>
          </template>
        </el-row>

        <div
          v-if="!list.length && !loadingTrue"
          style="width: 1200px; margin: 0 auto; margin-bottom: 10px"
        >
          <BaseEmptyData></BaseEmptyData>
        </div>
      </div>
    </div>
    <!-- <Pagination
      v-if="param.total > 0 && !loading"
      :param="param"
      @change="getlist"
      :loading="loading"
    ></Pagination> -->
  </div>
</template>

<script>
import { apiFlexibleEmployment } from "@/api/apiFlexibleEmployment"
import { apiResignAll } from "@/api/apiResignAll"
import SortBtn from "@/components/sortBtnGroup/SortBtn"
import { mapState } from "vuex"
const throttle = require("lodash/throttle");
export default {
  name: "labor",
  components: {
    ScreenSort: () => import("@/components/screenSort/screenSort"),
    Pagination: () => import("@/components/card/page"),
    card: () => import("@/components/card/cardLabor.vue"),
    BaseEmptyData: () => import("@/components/public/BaseEmptyData"),
    SortBtn
  },
  props: {
    top: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      moreLoading: false, //加载更多
      nomore: false, //没有数据显示
      loadingTrue: true,
      list: [],
      params: {},
      param: {
        page: 1,
        limit: 40,
        total: 0,
        sortType: 1,
        distanceSortType: 1,
        timeSortType: 1,
        totalPages: 0
      },
      update: true,
      distance: true
    }
  },
  watch: {
    // 页数改变的时候
    "param.page": {
      handler(val) {
        if (val > this.param.totalPages) {
          this.nomore = true;
        } else {
          this.nomore = false;
        }
      },
    },
  },
  computed: {
    //获取坐标经纬度
    ...mapState({
      position: state => state.position
    })
  },
  methods: {
    async getlist() {
      this.moreLoading = true //加载更多显示
      let params = { ...this.params }
      // params.current = this.param.page //es页码字段
      params.page = this.param.page //数据库页码字段
      params.limit = this.param.limit
      params.sortType = this.param.sortType //排序类型
      params.distanceSortType = this.param.distanceSortType //距离排序顺序
      params.timeSortType = this.param.timeSortType //时间排序顺序
      params.latitude = this.position.lat //纬度
      params.longitude = this.position.lng //经度
      this.param.total = 0
      //查询数据库的接口
      let res = await apiFlexibleEmployment.laborEmploymentList(params)
      this.loadingTrue = false
      if (res && res.data.code === 200) {
        this.param.total = res.data.data.total
        this.list = [...this.list,...res.data.data.records]
        this.param.totalPages=res.data.data.pages;
        this.moreLoading = false //加载更多隐藏
        this.$parent.count3 = res.data.data.total
      }
      //查询es的接口
      // apiResignAll
      //   .searchLabor(params)
      //   .then(res => {
      //     if (res && res.data.code == 200) {
      //       this.param.total = res.data.data.total
      //       this.$parent.count3 = res.data.data.total
      //       this.list = res.data.data.records
      //     }
      //   })
      //   .finally(() => {
      //     this.loading = false
      //   })
    },
     // 页面滚动
    windowScroll: throttle(
      function () {
        // 如果当前页数大于总页数 则不去获取
        let scrollTop =
          document.documentElement.scrollTop ||
          window.pageYOffset ||
          document.body.scrollTop;
        let scrollHeight =
          document.documentElement.scrollHeight || document.body.scrollHeight;
        let clientHeight =
          document.documentElement.clientHeight || document.body.clientHeight;
        /**
         * clientHeight 视口大小
         * scrollHeight 文档高度
         */
        if (scrollTop + clientHeight >= scrollHeight - 300) {
          this.param.page += 1;
          if (this.param.page <= this.param.totalPages) {
            this.getList()
          }
        }
      },
      1500,
      { leading: false, trailing: true }
    ),
    changeobj(obj) {
      this.param.page = 1
      let params = {}
      this.list = []
      this.loadingTrue = true
      //获取行业类别
      if (obj.industryType) {
        params.industryNo = obj.industryType[0] ? obj.industryType[0].no : ""
        params.categoryNo = obj.industryType[1] ? obj.industryType[1].no : ""
        params.workNo = obj.industryType[2] ? obj.industryType[2].no : ""
      }
      //获取地区
      params.provinceNo = obj.locationAddresscode.provinceId
      params.cityNo = obj.locationAddress?obj.locationAddresscode.cityId:'';
      params.areaNo = obj.locationAddress
        ? obj.locationAddress.map(v => {
            return v.no
          })
        : []
      if(obj.locationAddresscode.isAll){
        params.areaNo=params.areaNo[0]
      }
      //获取搜索值
      params.keyWord = localStorage.getItem("search_query")

      //设置值
      this.params = params
      this.getlist()
    },
    getList() {
      this.param.page = 1
      this.list = []
      this.loadingTrue = true
      this.getlist()
    }
  },
  mounted(){
    document.addEventListener("scroll", this.windowScroll);
  },
   beforeDestroy() {
    document.removeEventListener("scroll", this.windowScroll);
  },
  provide() {
    return {
      cardListCom: this
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  position: relative;
  width: 1198px;
  margin: 0 auto;
  overflow: hidden;
  min-height: 400px;
  background: white;
  border-right: 1px solid #e4e7ed;
  border-left: 1px solid #e4e7ed;
  border-bottom: 1px solid #e4e7ed;
  /deep/ .right {
    right: 0;
  }
}
.course-loading-wrap {
    display: flex;
    padding-top: 10px;
    font-size: 14px;
    align-items: center;
    justify-content: center;
    color: #999;
    background: #fff;
    .loading-icon {
      margin-left: 12px;
      font-size: 24px;
    }
  }
</style>
